<template>
  <v-row v-if="cols && cols.length > 0" wrap>
    <v-col
      v-for="(item, index) in cols"
      :key="index"
      cols="12"
      sm="6"
      md="4"
    >
      <template v-if="index <= 2">
        <v-img
          :src="item[0].type === 'image' &&
                item[0].url ? item[0].url :
                item[1].type === 'image' &&
                item[1].url ? item[1].url :
                item[2].type === 'image' &&
                item[2].url ? item[2].url :
                `${require('@/assets/images/optin/image-03.png')}`"
          aspect-ratio="1.7778"
          class="mb-4"
        ></v-img>

        <div class="box-outlined">
          <v-layout
            d-block
            d-md-flex
            row
            ma-0
            align-center
            justify-space-between
            class="box-header"
          >
            <v-flex xs12>
              <h2 v-if="item[0].type === 'title' && item[0].text" class="box-header-item mb-3 mb-md-0" v-html="item[0].text"></h2>
              <h2 v-if="item[1].type === 'title' && item[1].text" class="box-header-item mb-3 mb-md-0" v-html="item[1].text"></h2>
              <h2 v-if="item[2].type === 'title' && item[2].text" class="box-header-item mb-3 mb-md-0" v-html="item[2].text"></h2>
            </v-flex>
          </v-layout>

          <div class="box-content pa-0">
            <!-- check if modules is not empty -->
            <v-layout
              class="box-content-item pa-4"
              d-block
              d-md-flex
              row
              ma-0
              align-center
              justify-space-between
            >
              <template v-if="item[0].type === 'text' && item[0].text">
                <pre v-if="item[0].type === 'text' && item[0].text" :key="index">
                  <div v-html="item[0].text"></div>
                </pre>
              </template>
              <template v-if="item[1].type === 'text' && item[1].text">
                <pre v-if="item[1].type === 'text' && item[1].text" :key="index">
                  <div v-html="item[1].text"></div>
                </pre>
              </template>
              <template v-if="item[2].type === 'text' && item[2].text">
                <pre v-if="item[2].type === 'text' && item[2].text" :key="index">
                  <div v-html="item[2].text"></div>
                </pre>
              </template>
            </v-layout>
          </div>
        </div>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import { getStatic } from '@/js/static/getStatic'

export default {
  data () {
    return {
      cols: []
    }
  },

  async created () {
    // if (!this.$store.getters['auth/isAuthenticated']) return

    const params1 = {
      lang: this.$i18n.locale ? this.$i18n.locale : 'fr',
      page: 'welcome',
      keyword: 'col1'
    }
    await getStatic(params1)
      .then(response => this.cols.push(response.modules))
      // .catch(error => console.log(error))

    const params2 = {
      lang: this.$i18n.locale ? this.$i18n.locale : 'fr',
      page: 'welcome',
      keyword: 'col2'
    }
    await getStatic(params2)
      .then(response => this.cols.push(response.modules))
      // .catch(error => console.log(error))

    const params3 = {
      lang: this.$i18n.locale ? this.$i18n.locale : 'fr',
      page: 'welcome',
      keyword: 'col3'
    }
    await getStatic(params3)
      .then(response => this.cols.push(response.modules))
      // .catch(error => console.log(error))
  }
}
</script>
